import { graphql } from 'gatsby';
import { ImageElement, RichTextElement } from '@kontent-ai/gatsby-components';
import {
  StyledBody,
  StyledLink,
  StyledEyebrow,
  StyledHeadline,
  StyledContent,
  StyledImage,
  StyledSection,
  StyledContainer,
} from './N5050CardBlock.styles';
import { applyPaddingCSS } from '@/utils/generatePadding';
import { type BlockHTMLId } from '@/utils/renderBlock';

const N5050CardBlock = ({
  n5050CardBlockElements: elements,
  system,
  id,
}: Queries.N5050_CARD_BLOCKFragment & BlockHTMLId) => {
  const { headline, image, link, body, eyebrow, variant } = elements;
  const imageCard = {
    ...image.value,
    description: image.value.description || image.value.url,
    image_id: image.value.url,
    height: image.value.height!,
    width: image.value.width!,
  };
  return (
    <StyledContainer css={applyPaddingCSS(elements)} data-codename={system.codename} id={id}>
      <StyledSection>
        <StyledContent variant={variant.value}>
          <StyledEyebrow>{eyebrow.value}</StyledEyebrow>
          <StyledHeadline>{headline.value}</StyledHeadline>
          <StyledBody>
            <RichTextElement value={body.value} />
          </StyledBody>
          <StyledLink {...link.value} variant="tertiary_no_underline" />
        </StyledContent>
        <StyledImage variant={variant.value}>
          <ImageElement
            image={{
              ...imageCard,
            }}
            width={imageCard.width}
            height={imageCard.height}
            alt={imageCard.description}
          />
        </StyledImage>
      </StyledSection>
    </StyledContainer>
  );
};

export default N5050CardBlock;

export const fragment = graphql`
  fragment N5050_CARD_BLOCK on kontent_item_n5050_card_block {
    system {
      codename
      type
      id
    }
    n5050CardBlockElements: elements {
      ...COMPONENT_A_B_TEST
      ...PADDING
      eyebrow {
        value
      }
      headline {
        value
      }
      image {
        value {
          description
          height
          url
          width
        }
      }
      variant {
        value
      }
      body {
        value
      }
      link {
        value {
          ...LINK
        }
      }
    }
  }
`;
